@if (message(); as message) {
  @if (message.content['msgtype'] !== 'm.bad.encrypted' && toolbarOpen && room(); as room) {
    <mat-toolbar
      class="message-toolbar"
      [class.menu-open]="isMenuOpen"
      (mouseenter)="setToolbarMessageId(message.id)"
      [ngClass]="clientService.client.getUserId() === message?.senderId ? 'msgSend' : 'msgReceived'">
      @for (emoji of emojiList; track emoji?.id) {
        @if (emoji) {
          <button class="last_added_emoji" [attr.data-testid]="emoji.id" (click)="sendReaction(emoji)">
            <ngx-emoji class="edit-icon" [emoji]="emoji.id"></ngx-emoji>
          </button>
        }
      }
      <app-sb-reaction
        [room]="room"
        (toolbarMessageId)="setToolbarMessageId($event)"
        [message]="message"></app-sb-reaction>
      <app-sb-edit-message
        [room]="room"
        (toolbarMessageId)="setToolbarMessageId($event)"
        [message]="message"></app-sb-edit-message>
      @if (!message.isRedacted) {
        <mat-menu
          #menu="matMenu"
          [class]="clientService.client.getUserId() === message?.senderId ? 'msgSend' : 'msgReceived'">
          @for (menuComponent of menuComponents; track menuComponent) {
            @switch (menuComponent.title) {
              @case ('respond') {
                <app-sb-respond-message [message]="message"></app-sb-respond-message>
              }
              @case ('delete') {
                <!-- Delete Dialog -->
                @if (showDeleteMessageMenuItem(message)) {
                  <mat-divider class="divider"></mat-divider>
                  <button
                    mat-menu-item
                    type="button"
                    (click)="onDeleteMenuItemClick($event, message)"
                    matTooltip="Diese Nachricht kann innerhalb von 24 Stunden gelöscht werden"
                    [attr.aria-disabled]="!canDeleteMessage(message) ? 'true' : null"
                    [class.delete-menu-item-disabled]="!canDeleteMessage(message)"
                    [attr.data-testid]="testIds.buttonOpenDeleteDialog">
                    <mat-icon svgIcon="delete-icon"></mat-icon>
                    Löschen
                  </button>
                }
              }
              @case ('report') {
                @if (clientService.client.getUserId() !== message?.senderId) {
                  <mat-divider class="divider"></mat-divider>
                  <button
                    mat-menu-item
                    [attr.data-testid]="testIds.buttonOpenReportDialog"
                    (click)="openReportDialog(reportDialog, message)">
                    <mat-icon svgIcon="triangle-exclamation"></mat-icon>
                    Melden
                  </button>
                }
              }
              @case ('pin') {
                <mat-divider class="divider"></mat-divider>
                @if (message.isPinned) {
                  <button
                    mat-menu-item
                    (click)="pinnedMessageService.unpinMessage(message.eventId)"
                    [attr.data-testid]="testIds.buttonPinMessage">
                    <mat-icon svgIcon="pin-icon"></mat-icon>
                    Lösen
                  </button>
                } @else {
                  <button
                    mat-menu-item
                    (click)="pinnedMessageService.pinMessage(message.eventId)"
                    [attr.data-testid]="testIds.buttonPinMessage">
                    <mat-icon svgIcon="pin-icon"></mat-icon>
                    Pin
                  </button>
                }
              }
            }
          }
        </mat-menu>
        <button
          mat-icon-button
          [matMenuTriggerFor]="menu"
          class="menu-trigger"
          [attr.data-testid]="testIds.buttonMoreMenu">
          <mat-icon [svgIcon]="'more-settings'" class="menu-icon"></mat-icon>
        </button>
      }
    </mat-toolbar>
  }
}

<ng-template #reportDialog let-data>
  <form (ngSubmit)="reportEvent(data.eventId)" [formGroup]="reportForm">
    <mat-dialog-content [attr.data-testid]="testIds.reportDialogContent">
      <div class="custom-div-dialog-icon">
        <mat-icon class="warning-icon" svgIcon="circle-warning"></mat-icon>
      </div>

      <h2 class="dialog-title" mat-dialog-title>MELDEN EINER NACHRICHT</h2>
      <div class="report-dialog-content" mat-dialog-content>
        <p class="dialog-message">Wollen sie folgende Nachricht melden?</p>
        <p
          [innerHTML]="data.messageText"
          class="message-to-report"
          [attr.data-testid]="testIds.messageToReportText"></p>
        <p class="send-from">{{ data.sender }}</p>
        <div class="submessage">
          <p class="bold-submessage">Bitte geben Sie einen eindeutigen Meldegrund an.</p>
          <mat-form-field class="report-reason">
            <textarea
              [attr.data-testid]="testIds.reportReasonTextarea"
              cdkAutosizeMaxRows="15"
              cdkAutosizeMinRows="5"
              cdkTextareaAutosize
              formControlName="reportReason"
              matInput
              placeholder="Meldungsgrund"></textarea>
          </mat-form-field>
        </div>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions class="report-dialog-actions" [attr.data-testid]="testIds.reportDialogActions">
      <app-button
        (clicked)="matDialog.closeAll()"
        [attr.data-testid]="testIds.cancelReportButton"
        mat-dialog-close
        text="Abbrechen">
      </app-button>
      <app-button
        [isPrimary]="true"
        [attr.data-testid]="testIds.confirmReportButton"
        text="Nachricht melden"
        type="submit">
      </app-button>
    </mat-dialog-actions>
  </form>
</ng-template>
